export default {
  id: 'Permissions',
  code: 'CN',
  text: {
    'Permissions': '权限设置',
    'Warning': '警告',
    'The following permissions will be disabled in order to complete your request.': '以下权限将会关闭',
    'New permission group created': '新权限组生成',
    'Create Group':'添加新权限组',
    'Add Member':'添加成员',
    'This permission group will be deleted permanently.':'此权限组将会永久删除',
    'Permission must not be empty.':'权限设置不能为空',
    'Failed to save':'保存失败',
    'There is an error, please try again':'发生了一个错误',
    'Settings Saved':'设置已保存',
    'Save':'保存',
    'Permission Group Name':'新权限组名称',
    'Cancel':'取消',
    'Edit Group':'编辑权限组',
    'Teachers':'老师',
    'Delete Permission Group':'删除权限组',
    'Group Member':'权限组成员',
    'Deleting Permission Group':'删除权限组',
    'View student channel': '查看学生频道',
    'Edit student':'编辑学生',
    'Edit classroom':'编辑教室',
    'Edit teacher':'编辑老师',
    'View student task': '查看学生规划',
    'Edit student notes': '编辑学生备注',
    'Assign student to class': '将学生分配到班级',
    'Recover student in school': '恢复本校学生',
    'Export student to excel': '导出学生至 Excel',
    'View student trade record': '查看学生缴费记录',
    'Create private class': '新建私课',
    'View student detail': '查看学生详细信息',
    'View student check in record': '查看学生签到记录',
    'Create class and assign multiple student': '新建班级并分配多个学生',
    'Edit student task': '编辑学生规划',
    'Edit transaction notes': '编辑缴费备注',
    'Archive student from class': '从班级里归档学生',
    'Charge student fee': '对学生进行收费',
    'Send transaction email': '发送缴费记录邮件',
    'View class of student': '查看学生所在班级',
    'Create student': '新建学生',
    'Create student task': '新建学生规划',
    'Edit school information and student registration field': '修改学校信息以及注册自定义',
    'Delete student task': '删除学生规划',
    'Archive student from school': '从学校里归档学生',
    'Refund for student': '给学生退款',
    'Change student task status': '完成学生规划',
    'View class channel': '查看班级频道',
    'View class detail': '查看班级信息',
    'Create class': '创建班级',
    'Edit, delete lesson': '编辑，删除课节',
    'Archive teacher from class': '从班级里归档老师',
    'View student in class': '查看班级里的学生',
    'Create lesson': '新建课节',
    'Manually check in for student and teacher': '手动给学生老师签到',
    'View teacher in class': '查看班级里的老师',
    'Edit class': '编辑班级',
    'Close/archive class': '关闭、归档班级',
    'Assign teacher to class': '将老师分配到班级',
    'View private class channel': '查看私课频道',
    'View private class detail': '查看私课信息',
    'Create private lesson': '新建私课课节',
    'Archive teacher from private class': '从私课里归档老师',
    'View teacher of private class lesson': '查看私课里的老师',
    'Edit private class': '编辑私课',
    'Assign teacher to private class': '将老师分配到私课',
    'Edit private lesson': '编辑私课课节',
    'Close/archive private class': '关闭、归档私课',
    'View teacher channel': '查看老师频道',
    'View teacher check in record': '查看老师签到',
    'Invite teacher to school': '邀请老师',
    'Create teacher': '新建老师',
    'Archive teacher from school': '从学校里归档老师',
    'Recover teacher in school': '从学校里恢复老师',
    'Assign teacher to private class': '将老师分配到私课',
    'Navigation': '查看导航栏',
    'Create and publish poster': '新建发布海报',
    'View contact channel': '查看联系人频道',
    'Create classroom': '新建班级',
    'Create contact': '新建联系人',
    'Create and publish announcement': '新建发布公告',
    'Start smart check in': '使用智能签到',
    'Staff operation log notification in web browser':'教务操作记录通知',
    'View classroom channel': '查看教室频道',
    'Delete classroom': '删除班级',
    'View announcement channel': '查看公告频道',
    'Edit announcement': '编辑公告',
    'Delete announcement': '删除公告',
    'View poster channel': '查看海报频道',
    'Edit, publish, un-publish, delete poster': '编辑、发布、下架、删除海报',
    'Convert attendee to student': '转换海报报名人为学生',
    'Edit contact': '编辑联系人',
    'Edit contact notes': '编辑联系人备注',
    'Edit contact tag': '编辑联系人标签',
    'Convert contact to student': '转换联系人为学生',
    'View group and permission setting channel': '查看权限频道',
    'Create group and permission': '新建权限组',
    'Edit group and permission': ' 编辑权限组权限',
    'View timetable channel': '查看课表频道',
    'View school settings channel': '查看学校设置频道',
    'View finance channel': '查看财务频道',
    'Export transaction to excel': '导出财务记录为 Excel',
    'View operation log channel': '查看操作记录频道',
    'View teacher app': '使用老师 app',
    'Change student task status in teacher app': '在老师 app 中更改学生规划状态',
    'Manually check in for student and teacher in teacher app': '在老师 app 中手动给学生老师签到',
    'The following permissions will be enabled in order to complete your request.': '如果你想完成此操作，以下权限将会自动开启',
    'View contact detail':'查看联系人详情',
    'View teacher detail':'查看老师详情',
    'View class of teacher':'查看老师所在班级',
    'Edit contact custom fields':'编辑联系人自定义字段',
    'Read teacher punch card record': '查看老师打卡记录',
    'Create, edit and delete teacher punch card record': '新建, 修改, 删除老师打卡记录'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolSettings/Permissions/locale.js